import { useQuery } from "@tanstack/react-query"
import { carrotClient } from "../../../utils/CarrotClient"
import buildCarrotApiRetryPolicy from "../../../utils/CarrotApiRetryPolicy"

export const REGISTRATION_JOURNEY_QUERY_KEY = "GetRegistrationJourney"

export function useGetRegistrationJourney() {
  const { data: registrationJourneyResult, isLoading: isRegistrationJourneyLoading } = useQuery(
    [REGISTRATION_JOURNEY_QUERY_KEY],
    () => carrotClient.getRegistrationJourney(),
    {
      retry: buildCarrotApiRetryPolicy(3),
      staleTime: Infinity
    }
  )
  return {
    registrationJourneyResult,
    isRegistrationJourneyLoading
  }
}
